import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()

    return {
        close: {
          width: '100%',
          display: 'flex',
          justifyContent: 'end',
          marginRight: '-10px',
          //padding: '0px 24px',
          '& .MuiSvgIcon-root': {
              fontSize: '2rem',
              color: colors.color13,
          }
      },
        bigScreens: {
          [breakpoints.down(1200)]: {
            display: 'none'
          }
        },
        smallScreens:{
          display: 'none',
          [breakpoints.down(1200)]: {
            display: 'block'
          }
        }        
    }
}

export { useStyles }